export default __webpack_public_path__ + "static/RootSans-6Italic-729854e54ee6cc7d61a08810c77d6935.woff2";